export function validateAsset(store,meta){    
    let autorizado = store.includes(meta) 

    if (autorizado) {
        return true
    } else {
        return false
    }
}